module.exports = __webpack_public_path__ + "static/media/person3.1b284eb7.png";